import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "assets/scss/dashboard.scss";
import "assets/css/charts_form_controls.css";
import "assets/css/grid_table.css";
import numeral from "numeral";
import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import Select from "react-select";
import { Divider } from "primereact/divider";
import moment from "moment";
import { getDataApi, saveApi,postDataApi, loadApi } from "services/appApi";
import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";
import axios from "axios";

const ItemUselotAssignment = () => {
  let emptyRow = {
    user_id: null,
    use_lot_type_id:null,
    use_lot_type:"",
    use_lot_item_name:"",
    use_lot_format:"",
    organization_id:22,
    inventory_item_id:null,
    use_lot_item_name_disp:"",
    start_date_active:"",
    end_date_active:"",
    use_lot_type_item_id:null,
    row_id:"",
    inv_use_lot_type_item_id:null,
    ora_item_number:"",
    default_qty:null,
     };

  const [rows, setRows] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [deleteRowDialog, setDeleteRowDialog] = useState(false);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [dialog, setDialog] = useState("");
  const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] = useState(true);
  const toast = useRef(null);
  const dt = useRef(null);


  
  const [fetchUselotTypeLov, setFetchUselotTypeLov] = useState(true);
  const [fetchUselotTypeItemLov, setFetchUselotTypeItemLov] = useState(true);
  const [fetchUselotItemNumberLov, setFetchUselotItemNumberLov] = useState(true);

  const [uselotType, setUselotType] = useState([]);
  const [uselotTypeItem, setUselotTypeItem] = useState([]);  
  const [uselotItemNumber, setUselotItemNumber] = useState([]);

  const [uselotTypeId, setUselotTypeId] = useState({label: "", value: null});
  const [uselotTypeItemId, setUselotTypeItemId] = useState({label: "", value: null});
  const [uselotItemNumberId, setUselotItemNumberId] = useState({label: "", value: null});

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [uselotTypeSelectId, setUselotTypeSelectId] = useState({label: "", value: null});
  const [uselotTypeItemSelectId, setUselotTypeItemSelectId] = useState({label: "", value: null});
  const [useloItemNumberSelectId, setUselotItemNumberSelectId] = useState({label: "", value: null});
  
  
  
///////////////////////////////////////////////////////////////////////////
useEffect(() => {
        const fetchUselotItemNumberLov = async () => {
          setFetchUselotItemNumberLov(true);
          try {
            let res = await postDataApi("/api/setup/useLots/uselotMachAssignment/uselotItemNumberLov");
            if (res) {
              let successFlag = res.data[0];
              console.log("UselotItemNumber ",res);
              console.log("Success Flag",successFlag);
              if (successFlag === "Y" && Array.isArray(res.data[1])) {
                const options= res.data[1].map((item)=>({
                  label: item.item_number,
                  value: item.inventory_item_id,
                  rowId: item.rowid
                }))
                setUselotItemNumber(options)
                setFetchUselotItemNumberLov(false);
              } 
            }
          } catch (err) {
            console.log(err);
            setFetchUselotItemNumberLov(false);
          }
        };
        fetchUselotItemNumberLov();
      }, []);

useEffect(() => {
        const fetchUselotTypeLov = async () => {
          setFetchUselotTypeLov(true);
          try {
            let res = await postDataApi("/api/setup/useLots/uselotMachAssignment/uselotTypeLov");
            if (res) {
              let successFlag = res.data[0];
              console.log("UselotTypeLov: ",res);
              console.log("Success Flag",successFlag);
              if (successFlag === "Y" && Array.isArray(res.data[1])) {
                const options= res.data[1].map((item)=>({
                  label: item.use_lot_type,
                  value: item.use_lot_type_id
                }))
                setUselotType(options)
                setFetchUselotTypeLov(false);
              } 
            }
          } catch (err) {
            console.log(err);
            setFetchUselotTypeLov(false);
          }
        };
        fetchUselotTypeLov();
      }, []);

useEffect(() => {
        const fetchUselotTypeItemLov = async () => {
          setFetchUselotTypeItemLov(true);
          try {
            let res = await postDataApi("/api/setup/useLots/uselotMachAssignment/uselotTypeItemLov");
            if (res) {
              let successFlag = res.data[0];
              console.log("UselotTypeItem: ",res);
              console.log("Success Flag",successFlag);
              if (successFlag === "Y" && Array.isArray(res.data[1])) {
                const options= res.data[1].map((item)=>({
                  label: item.use_lot_item_name,
                  value: item.use_lot_type_item_id
                }))
                setUselotTypeItem(options)
                setFetchUselotTypeItemLov(false);
              } 
            }
          } catch (err) {
            console.log(err);
            setFetchUselotTypeItemLov(false);
          }
        };
        fetchUselotTypeItemLov();
      }, []);


//////////////////////////////////////////////////////////////////////////
            

  
  // Fetch Processes when the component mounts
  const handleLoadData = async () => {

    const p_param = {
        p_use_lot_type_id:uselotTypeId.value,
        p_use_lot_type_item_id:uselotTypeItemId.value,
        p_ora_item_number: uselotItemNumberId.label,
        p_start_date_active: startDate,
        p_end_date_active: endDate,
    };
    console.log(p_param);
      try {
        setIsLoading(true);
        const response = await loadApi(p_param,"/api/setup/useLots/uselotMachAssignment/selRows");
        console.log(response);
        console.log("Fetched INV Uselot Type Item :", response.data);
        console.log(response.data[0]);
        console.log(response.data[1]);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            console.log("success=Y");
            setRows(response.data[1]);
            setIsLoading(false);
            setWasDataFetchingSuccessful(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
            const errorInfo = response.data[2];

            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
            setWasDataFetchingSuccessful(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error("Error fetching Machine Names:", error);
      }
      } finally {
      setIsLoading(false);
    }
    };

  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
  };
  const openNew = () => {
    setRow(emptyRow);
    setUselotTypeSelectId({label: "", value: null});
    setUselotTypeItemSelectId({label: "", value: null});
    setUselotItemNumberSelectId({label: "", value: null});
    setSubmitted(false);
    setRowDialog(true);
    setDialog("create")
  };

  const hideDialog = () => {
    setSubmitted(false);
    setRowDialog(false);
    setDialog("")
    setShowProductDialog(false);
    setErrorDialogVisible(false);
  };

  const formatDateColumn = (dateValue) => {
    return dateValue ? moment.utc(dateValue).format("DD-MMM-YYYY") : null;
  };

  const startDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.start_date_active);
  };

  const endDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.end_date_active);
  };

 

  const saveRow = async () => {
    setSubmitted(true);
      //      const isNew = !row.process_id;
      //     const formattedRow = formatDateFields(row, isNew);

      let _rows = [...rows];
      let _row = { ...row };

      try {
        if (row.inv_use_lot_type_item_id) {
          /*** Update Row */
          const response = await saveApi(row, "/api/setup/useLots/uselotMachAssignment/updRow");
         
          console.log("updating");
          console.log(response.data);
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            const index = findIndexById(row.inv_use_lot_type_item_id);
            _rows[index] = _row;
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Inv Uselot Type Item Updated",
              life: 3000,
              width: "600px",
            });
          } else {
            let err_msg = response.data[1];
            toast.current.show({
              severity: "error",
              summary: err_msg,
              detail: "Inv Uselot Type Item Not Updated",
              life: 3000,
              width: "600px",
            });
          }
        } else {
          /*** Insert Row */
          const response = await saveApi(row, "/api/setup/useLots/uselotMachAssignment/insRow");
          
          console.log("saving");
          console.log("Response data: ", response.data);
          console.log("Response: ", response);
          let successFlag =
            response.data[0]; /** This contains value of Y or N */
          if (successFlag === "Y") {
            _row.inv_use_lot_type_item_id =
              response.data[1]; /** It contains newly created Id */

              console.log("newly created id",response.data[1])
            _rows.push(_row);
            handleLoadData();
            toast.current.show({
              severity: "success",
              summary: (
                <div style={{ marginright: "200px", width: "600px" }}>
                  Success
                </div>
              ),
              detail: <div style={{ width: "600px" }}>Inv Use Lot Type Item Created</div>,
              life: 3000,
              width: "600px",
            });
          } else {
            let err_msg = response.data[2];
            toast.current.show({
              severity: "error",
              summary: <div style={{ width: "600px" }}>{err_msg}</div>,
              detail: <div style={{ width: "600px" }}>{err_msg}</div>,
              life: 3000,
              width: "600px",
            });
          }
        }

        setRows(_rows);
        setRowDialog(false);
        setRow(emptyRow);
      } catch (error) {
        console.error("Error saving Inv Use Lot Type Item:", error);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Inv Use Lot Type Item Save Failed",
          life: 3000,
          width: "600px",
        });
      }
  };

  const editRow = (row) => {
    setRow({ ...row });
    setUselotTypeSelectId({label: row.use_lot_type, value: row.use_lot_type_id});
    setUselotTypeItemSelectId({label: row.use_lot_item_name, value: row.use_lot_type_item_id});
    setUselotItemNumberSelectId({label: row.ora_item_number, value: row.inventory_item_id});
    setRowDialog(true);
    setDialog("edit")
  };

  const findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].inv_use_lot_type_item_id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const hideDeleteRowDialog = () => {
    setDeleteRowDialog(false);
  };

   const confirmDeleteRow = (row) => {
      setRow(row);
      setDeleteRowDialog(true);
    };
   
        const deleteRow = async () => {
         try {
           const response = await saveApi(row, "/api/setup/useLots/uselotMachAssignment/delRow");
           let successFlag = response.data[0];
           if (successFlag === "Y") {
             let _rows = rows.filter((val) => val.row_id !== row.row_id);
             //let _rows = rows.filter((val) => val.inv_use_lot_type_item_id !== row.inv_use_lot_type_item_id);

             setRows(_rows);
             setDeleteRowDialog(false);
             setRow(emptyRow);
             toast.current.show({
               severity: "success",
               summary: "Successful",
               detail: "Inv Use Lot Type Item Deleted",
               life: 3000,
               width: "600px",
             });
           } else {
             let err_msg = response.data[1];
             toast.current.show({
               severity: "error",
               summary: err_msg,
               detail: "Inv Use Lot Type Item Deleted",
               life: 3000,
               width: "600px",
             });
           }
         } catch (error) {
           console.error("Error deleting Inv Use Lot Type Item :", error);
           toast.current.show({
             severity: "error",
             summary: "Error",
             detail: "Inv Use Lot Type Item Deletion Failed",
             life: 3000,
             width: "600px",
           });
         }
       };
       
       const deleteRowDialogFooter = (
               <React.Fragment>
                 <Button
                   label="No"
                   icon="pi pi-times"
                   className="p-button-text"
                   onClick={hideDeleteRowDialog}
                 />
                 <Button
                   label="Yes"
                   icon="pi pi-check"
                   className="p-button-text"
                   onClick={deleteRow}
                 />
               </React.Fragment>
             );

             const actionBodyDeleteTemplate = (rowData) => {
                       return (
                         <React.Fragment>
                           <Button
                             icon="pi pi-trash"
                             className="p-button-rounded p-button-warning"
                             onClick={() => confirmDeleteRow(rowData)}
                             tooltip="Delete"
                             tooltipOptions={{ position: "bottom" }}
                             disabled={false}
                           />
                         </React.Fragment>
                       );
                     };

  const getLoadingHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="row d-flex justify-content-center m-5">
          <div className="col-auto">
            <div className="card shadow-sm border-primary">
              <div className="card-header bg-primary text-white">
                <h2 className="mb-0">PDCS Inventory Item - Use Lot Assignment Inquiry </h2>
              </div>
              <div className="card-body text-center">
                <h3>
                  <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                  The page is loading...
                </h3>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  const getLoadedHeaderContents = () => {
                  return (
                    <React.Fragment>
                      <div className="header-container">
                        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        PDCS Inventory Item - Use Lot Assignment Inquiry
                        </h2>
                        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                          <div className="header-container p-1">
                              <style>
                              {`
                                input::placeholder {
                                  font-size: 17px; 
                                }
                              `}
                            </style>
                          {/* <span className="p-input-icon-right w-full md:w-auto"> 
                        <InputText
                          type="search"
                          onInput={(e) => setGlobalFilter(e.target.value)}
                          placeholder="Search..."
                          className="w-full lg:w-auto text-sm p-3"
                          style={{ fontSize: '17px' }} 
                        />
                      </span> */}
                          </div>
                        </h2>
                      </div>
                    </React.Fragment>
                  );
                }


  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };

 
const onInputUselotTypeSelectChange = (selectedOption, name, id) => {
    if(selectedOption == null) {
      setUselotTypeSelectId({label: "", value: null});
    } else {
    setUselotTypeSelectId(selectedOption);
    }
    const val = selectedOption != null ? selectedOption.value : null;
    const val1 = selectedOption != null ? selectedOption.label :"";

    let _row = { ...row };
    _row[`${id}`] = val;
    _row[`${name}`] = val1;

    setRow(_row);
  };

const onInputUselotTypeItemSelectChange = (selectedOption, name, id) => {
    if(selectedOption == null) {
      setUselotTypeItemSelectId({label: "", value: null});
    } else {
    setUselotTypeItemSelectId(selectedOption);
    }
    const val = selectedOption != null ? selectedOption.value : null;
    const val1 = selectedOption != null ? selectedOption.label :"";

    let _row = { ...row };
    _row[`${id}`] = val;
    _row[`${name}`] = val1;

    setRow(_row);
  };

  const onInputUselotItemNumberSelectChange = (selectedOption, name, id) => {
    if(selectedOption == null) {
      setUselotItemNumberSelectId({label: "", value: null});
    } else {
    setUselotItemNumberSelectId(selectedOption);
    }
    const val = selectedOption != null ? selectedOption.value : null;
    const val1 = selectedOption != null ? selectedOption.label :"";

    let _row = { ...row };
    _row[`${id}`] = val;
    _row[`${name}`] = val1;

    setRow(_row);
  };


  
  const onInputNumberChange = (e, name) => {
    const val = (e.target.valueAsNumber) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };

   const header = (
    <div
      className="table-header"
      style={{
        display: "flex",
        justifyContent: "space-between",
        height: "3rem",
        alignContent: "center",
      }}
    >
      <div
        style={{
          width: window.innerWidth / 3,
          display: "flex",
          justifyContent: "flex-start",
          marginRight: "110px",
        }}
      >
        <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span>
      </div>
      <div>
        <Button
          // label="New"
          icon="pi pi-plus"
          className="p-button-rounded p-button-success p-mr-2"
          onClick={openNew}
          tooltip="New"
          tooltipOptions={{ position: "bottom" }}
        />
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
          style={{ marginLeft: "20px" }}
        />
      </div>
    </div>
  );

  const actionBodyEditTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-success p-mr-2"
          onClick={() => editRow(rowData)}
          tooltip="Edit"
          tooltipOptions={{ position: "bottom" }}
          // disabled={true}
        />
      </React.Fragment>
    );
  };

  const sDate = row.start_date_active ? moment.utc(row.start_date_active).format("DD-MMM-YYYY") : null;
  const eDate = row.end_date_active ? moment.utc(row.end_date_active).format("DD-MMM-YYYY") : null;

  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

     const CardComponent = ({title, data}) => {
      const rightAlignedLabels = ["Sort Key : "];
    
          return (
            <Card className="card-containers">
              <h5  style={{"fontWeight":"bold"}}> {title} </h5>
              <Divider className="my-2" />
              {data.map((item, index) => (
                <div key={index} className="label-value-pair">
                  <span className="label">{item.label}</span>
                  
                  {item.label &&
                  <span         
                  className={`value-box ${rightAlignedLabels.includes(item.label) ? "align-right": ""}`}>
                    {item.value}</span>
                  }
                  
                </div>
              ))}
            </Card>
          )
        }


        const inputBoxStyle = {
    backgroundColor:"rgb(235, 235, 235)",
    padding: "6px 10px",
    borderRadius: "4px",
    display: "block",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    flexGrow: 1,
    minWidth: 0,
  }
  
  const inputRightBoxStyle = {
    textAlign: "right",
     outline: "0.015625rem thin #d3d3d3",
    borderradius: "5px", 
    border: "thin solid #d3d3d3",
    paddingLeft: "6px",
    borderRadius: "4px",
    backgroundColor:"rgb(235, 235, 235)",
    width: "100%",
  }
  const inputDateStyle = {
    outline: "0.015625rem thin #d3d3d3",
    borderradius: "5px", 
    border: "thin solid #d3d3d3",
    paddingLeft: "6px",
    borderRadius: "4px",
    backgroundColor:"rgb(235, 235, 235)",
    width: "100%",
  }
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`
  }

 

const handleUselotIdChange = (selectedOption) => {
    if(selectedOption == null) {
      setUselotTypeId({label: "", value: null});
    } else {
    setUselotTypeId(selectedOption);
    }
  }

  const handleUselotItemIdChange = (selectedOption) => {
    if(selectedOption == null) {
      setUselotTypeItemId({label: "", value: null});
    } else {
    setUselotTypeItemId(selectedOption);
    }
  }

  const handleUselotItemNumberIdChange = (selectedOption) => {
    if(selectedOption == null) {
      setUselotItemNumberId({label: "", value: null});
    } else {
    setUselotItemNumberId(selectedOption);
    }
  }

  const getUselotTypeControl = () => (
        <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Uselot Type</label>
         <Select
            // className="form-select"
            id="uselotTypeId"
            name="uselotTypeIdName"
            onChange={handleUselotIdChange}
            options={uselotType}
            value={uselotTypeId}
            placeholder="Select Use LOt"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown"
            classNamePrefix="select-dropdown"
          />
      </div>
    </React.Fragment>
      );

    const getUselotTypeItemControl = () => (
        <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Uselot Type Item</label>
         <Select
            // className="form-select"
            id="uselotTypeItemId"
            name="uselotTypeItemIdName"
            onChange={handleUselotItemIdChange}
            options={uselotTypeItem}
            value={uselotTypeItemId}
            placeholder="Select Use Lot Type Item"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown"
            classNamePrefix="select-dropdown"
          />
      </div>
    </React.Fragment>
      );

      const getUselotItemNumberControl = () => (
        <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Item Number</label>
         <Select
            // className="form-select"
            id="uselotItemNumberId"
            name="uselotItemNumberIdName"
            onChange={handleUselotItemNumberIdChange}
            options={uselotItemNumber}
            value={uselotItemNumberId}
            placeholder="Select Machine"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown"
            classNamePrefix="select-dropdown"
          />
      </div>
    </React.Fragment>
      );

   
      const getStartEndDateControls = () => (
          <React.Fragment>
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">Start Date Active</label>
              <div className="input-group date input-wrapper">
              <input
                type="date"
                id="StartDate"
                name="StartDate"
                value={startDate}
                onChange={handleStartDateChange}
                disabled={isLoading}
                className="input-outline1"
              />
              </div>
            </div>
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">End Date Active</label>
              <div className="input-group date input-wrapper">
              <input
                type="date"
                id="EndDate"
                name="EndDate"
                value={endDate}
                onChange={handleEndDateChange}
                disabled={isLoading}
                className="input-outline1"
              />
              </div>
            </div>
          </React.Fragment>
        );
      
        const handleStartDateChange = (e) => {
          setStartDate(e.target.value);
        };
      
        const handleEndDateChange = (e) => {
          setEndDate(e.target.value);
        };

     const getGoButtonControl = () => (
        <React.Fragment>
          <div className="col-auto d-flex align-items-center justify-content-center ps-2 pe-0" style={{paddingTop:'1.9375rem'}}>
            <button
              type="button"
              className="btn btn-primary load-button"
              id={"chartAreaId"}
              onClick={handleLoadData}
              disabled={isLoading}
            >
               <i
                className={
                  isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
                }
              ></i>
              <span>{isLoading ? "Loading" : "Go"}</span>
            </button>
          </div>
        </React.Fragment>
      );
  return (
    <div>
      <Toast ref={toast} />
    <div className="col mx-2">
        {fetchUselotTypeLov && fetchUselotTypeItemLov ? getLoadingHeaderContents() : getLoadedHeaderContents()}
        {!fetchUselotTypeLov && !fetchUselotTypeItemLov && (
        <div className="row">
          <div className="col">
            <div className="row justify-content-center">
              {getUselotTypeControl()}
              {getUselotTypeItemControl()}
              {getUselotItemNumberControl()}
              {getStartEndDateControls()}
              {getGoButtonControl()}              
                       
            </div>
            {!wasDataFetchingSuccessful && (
              <div className="card my-3">
              <DataTable
              ref={dt}
              value={rows}
              selection={selectedRows}
              onSelectionChange={(e) => setSelectedRows(e.value)}
              dataKey="inv_use_lot_type_item_id"
              scrollable
              scrollHeight="flex"
              className="custom-datatable-border"
              tableStyle={{ minWidth: "50rem" }}
              paginator
              rows={pecaPageRows}
              rowsPerPageOptions={pecaRowsPerPageOptions}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Machine"
              globalFilter={globalFilter}
              header={header}
              emptyMessage="No Data found"
              stripedRows
              showGridlines        
              responsiveLayout="scroll"
              rowExpansion
            >
              
              <Column
                body={readBodyTemplate}
                exportable={false}
                style={{ width: "0.75rem" }}
              ></Column>
              <Column
                field="inv_use_lot_type_item_id"
                header="id"
                sortable="false"
                hidden="true"
                exportable={false}
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="use_lot_item_name"
                header="Use Lot Item"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="use_lot_type"
                header="Use Lot Type"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              
              <Column
                field="ora_item_number"
                header="Item Number"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="default_qty"
                header="Defaut Qty"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="use_lot_format"
                header="Use Lot Format"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              
              
              <Column
                field="start_date_active"
                header="Active Start Date"
                body={startDateBodyTemplate}
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="end_date_active"
                header="Active End Date"
                body={endDateBodyTemplate}
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                body={actionBodyEditTemplate}
                style={{ width: "0.75rem" }}
              ></Column>
              <Column
              body={actionBodyDeleteTemplate}
              style={{ width: "0.75rem" }}
              ></Column>
            </DataTable>
          </div>
        )}
        </div>
        </div>
        )}
        <Dialog
          visible={rowDialog}
          style={{ width: "1400px" }}
          modal
          className="p-fluid"
          onHide={hideDialog}
        >
          <h4 style={{"fontWeight":"bold"}}> PDCS  Inventory Item - Use Lot Assignment Inquiry </h4>
          <Divider className="my-4" />
          <h5 style={{"fontWeight":"bold"}}>  {dialog === "edit" ? "Update UseLot Type Item" : dialog === "create" ? "Create New UseLot Type Item Information" : ""} </h5>
          <Divider className="my-4" />
          <div className="card-wrapper">
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Use Lot  Details </h5>
            <Divider className="my-2" />
            
          <div className="label-value-pair">
            <span className="label" htmlFor="use_lot_type_id"> Use Lot Type : </span>
            <span style={{flexGrow:1}}>
              <Select
            // className="form-select"
            id="uselotTypeSelectId"
            name="uselotTypeSelectIdName"
            onChange={(selectedOption) => onInputUselotTypeSelectChange(selectedOption, "use_lot_type", "use_lot_type_id")}
            options={uselotType}
            value={uselotTypeSelectId}
            placeholder="Select Use Lot type"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            lassName="select-dropdown2"
            classNamePrefix="select-dropdown2"
          />
            </span>
            {submitted && row.use_lot_type_id == null && dialog === "create" && (
              <small className="p-error">Use Lot Type is required.</small>
            )}
          </div> 

<div className="label-value-pair">
            <span className="label" htmlFor="use_lot_type_item_id"> Use Lot Type Item : </span>
            <span style={{flexGrow:1}}>
              <Select
            // className="form-select"
            id="uselotTypeSelectId"
            name="uselotTypeSelectIdName"
            onChange={(selectedOption) => onInputUselotTypeItemSelectChange(selectedOption, "use_lot_item_name", "use_lot_type_item_id")}
            options={uselotTypeItem}
            value={uselotTypeItemSelectId}
            placeholder="Select Use Lot type"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            lassName="select-dropdown2"
            classNamePrefix="select-dropdown2"
          />
            </span>
            {submitted && row.use_lot_type_item_id == null && dialog === "create" && (
              <small className="p-error">Use Lot Type is required.</small>
            )}
          </div> 

<div className="label-value-pair">
            <span className="label" htmlFor="inventory_item_id"> Ora Item Number 1 : </span>
            <span style={{flexGrow:1}}>
              <Select
            // className="form-select"
            id="itemNumberEdit"
            name="itemNumberEditName"
            onChange={(selectedOption) => onInputUselotItemNumberSelectChange(selectedOption, "item_number", "inventory_item_id")}
            options={uselotItemNumber}
            value={useloItemNumberSelectId}
            placeholder="Select Use Lot type"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            lassName="select-dropdown2"
            classNamePrefix="select-dropdown2"
          />
            </span>
            {submitted && row.inventory_item_id == null && dialog === "create" && (
              <small className="p-error">Use Lot Type is required.</small>
            )}
          </div> 
          
          </Card>
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Active Dates </h5>
            <Divider className="my-2" />
            <div className="label-value-pair">
            <span className="label" htmlFor="start_date_active">Active Start Date : </span>
            <span style={{flexGrow:1}} className="input-wrapper">
            <input
              type="date"
              id="start_date_active"
              defaultValue={formatDateTime(row.start_date_active)}
              onChange={(e) => onInputChange(e, "start_date_active")}
              style={inputDateStyle}
            />
            </span>
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="end_date_active">Active End Date : </span>
            <span style={{flexGrow:1}} className="input-wrapper">
            <input
              type="date"
              id="end_date_active"
              defaultValue={formatDateTime(row.end_date_active)}
              onChange={(e) => onInputChange(e, "end_date_active")}
              style={inputDateStyle}
            />
            </span>
          </div>
          </Card>

          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Other Details </h5>
            <Divider className="my-2" />


         

          <div className="label-value-pair">
            <span className="label"htmlFor="use_lot_format">Use Lot Format : </span>
            <span style={{flexGrow:1}}>
           <InputText
                // className="form-select"
                id="uselotFormatkEdit"
                name="uselotFormatEditName"
                value={row.use_lot_format}
                onChange={(e) => onInputChange(e, "use_lot_format")}
                placeholder="Enter Use Lot Remarks"
                style={inputBoxStyle}
                />
            </span>
            
          </div>

          



          <div className="label-value-pair">
            <span className="label"htmlFor="default_qty">Default Quantity : </span>
            <span style={{flexGrow:1}}>
           <input
           type="number"
           value={row.default_qty}
           onChange={(e) => onInputNumberChange(e, "default_qty")}
           style={inputRightBoxStyle}
           />
         
            </span> 
          </div>


          
          </Card>
          </div>
          <div className="btn-container">
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text"
            onClick={hideDialog}
            style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
          />
          <Button
            label="Save"
            icon="pi pi-check"
            className="p-button-text"
            onClick={saveRow}
            style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
          />
          </div>
        </Dialog>
          
       <Dialog visible={showproductDialog} style={{ width: '1400px' }} modal className="p-fluid" onHide={hideDialog}>     
                        <h4 style={{"fontWeight":"bold"}}> Inquire - UseLot Type Items </h4>
                        <Divider className="my-4" />
                        <h5 style={{"fontWeight":"bold"}}> View Use Lot Type Item Information </h5>
                        <Divider className="my-4" />
                        <div className="card-wrapper">
                          <CardComponent
                            title="Use Lot Type Item Details"
                            data={[
                              {label:"Use Lot Type : ", value: row.use_lot_type },
                              {label:"Use Lot Item  : ", value: row.use_lot_item_name },
                              {label:"Sort Key : ", value: row.sort_key},
                              {label:"Use Lot Format : ", value: row.use_lot_format},
                              {label:"Remark : ", value: row.use_lot_remarks},
                            ]}
                          />
                          <CardComponent
                            title="Active Dates"
                            data={[
                              {label:"Active Start Date : ", value: sDate },
                              {label:"Active End Date : ", value: eDate },
                            ]}
                          />
                         </div>
                    </Dialog>
                    <Dialog
                              visible={deleteRowDialog}
                              style={{ width: "450px" }}
                              header="Confirm"
                              modal
                              footer={deleteRowDialogFooter}
                              onHide={hideDeleteRowDialog}
                            >
                              <div className="confirmation-content">
                                <i
                                  className="pi pi-exclamation-triangle p-mr-3"
                                  style={{ fontSize: "1.5rem", paddingRight: "10px" }}
                                />
                                {row && (
                                  <span>
                                    Are you sure you want to delete <b>{row.inv_use_lot_type_item_id}</b>?
                                  </span>
                                )}
                              </div>
                            </Dialog>
                    <Dialog 
                        header="API Error" 
                        visible={errorDialogVisible} 
                        style={{ width: '400px' }} 
                        onHide={hideDialog} 
                        footer={
                            <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                        }
                    >    
                     <p>
        
                            {errorMessage}
                        </p>
                    </Dialog>
                    <style jsx>{`
                      .card-wrapper {
                        display: grid;
                        grid-template-columns: repeat(2,1fr);
                        gap: 10px;
                        padding: 5px;
                      }
        
                      .card-containers {
                        display: flex;
                        background-color: #f9f9f9;
                        flex-direction: column;
                        justify-content: flex-start;
                        border: 1px solid #ccc;
                        paddig: 10px;
                        box-shadow: 4px 4px 10px rgba(0,0,0,0.2);
                        height: auto;
                        width: 100%;
                      }
        
                      .label-value-pair {
                        display: flex;
                        flex-direction: row,
                        align-items: flex-start;
                        gap: 5px;
                        margin-bottom: 8px;
                        flex-wrap: wrap;
                      }
        
                      .label {
                        font-weight: bold;
                        white-space: nowrap;
                      }
        
                      .value-box {
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }

                      .align-right {
                        text-align: right;
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }

                      .btn-container {
                      display: flex;
                      justify-content: center;
                      gap:20px;
                      margin-top:20px;
                      }
                    `}
                    </style>
                    </div>
    </div>
  );
};

export default ItemUselotAssignment;